import { render } from "./BusinessPurposeSelectInput.vue?vue&type=template&id=09226c9b"
import script from "./BusinessPurposeSelectInput.vue?vue&type=script&lang=js"
export * from "./BusinessPurposeSelectInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__